var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCartVariantIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    id: "svg4",
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 18,18 c 0,1.11 -0.89,2 -2,2 -1.11,0 -2,-0.9 -2,-2 0,-1.11 0.89,-2 2,-2 1.11,0 2,0.9 2,2 M 6,16 c -1.11,0 -2,0.89 -2,2 0,1.1 0.89,2 2,2 1.11,0 2,-0.89 2,-2 C 8,16.89 7.11,16 6,16 M 6.2,12.63 6.17,12.75 C 6.17,12.89 6.28,13 6.42,13 H 18 v 2 H 6 C 4.89,15 4,14.1 4,13 4,12.65 4.09,12.32 4.24,12.04 L 5.6,9.59 2,2 H 0 V 0 H 3.27 L 4.21,2 H 19 c 0.55,0 1,0.45 1,1 0,0.17 -0.05,0.34 -0.12,0.5 L 16.3,9.97 C 15.96,10.58 15.3,11 14.55,11 H 7.1 L 6.2,12.63 M 7.5,9 H 9 V 7 H 6.56 L 7.5,9 M 10,7 v 2 h 3 V 7 H 10 M 13,6 V 4 h -3 v 2 h 3 m 3.11,1 H 14 v 2 h 1 L 16.11,7 M 17.78,4 H 14 v 2 h 2.67 L 17.78,4 M 5.14,4 6.08,6 H 9 V 4 Z",
    id: "path2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCartVariantIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cart-variant-icon.6d8bbc81384fc917e347c9f3af131e23.svg";